import "./bajaDeAplicacion.css";

const BajaDeAplicacion = () => {
  return (
    <div className="container py-4">
      <div className="secretaria_funciones">
        <h3 className="title">Baja de Aplicación</h3>
        <hr className="hr-gob" />
      </div>
      <div>
        <p>
          A continuación, te mostrare los pasos de cómo dar de baja tu cuenta de
          “CAASIM AVENTURAS”
        </p>

        <p>
          <strong>1. Accede a la app:</strong> Para dar de baja tu cuenta necesitaremos ingresar a la aplicación de “CAASIM AVENTURAS” en la cuenta que deseas dar de baja ingresando a la opción de sección parental como se muestra a continuación.
        </p>

        <div className="tutorial-image-container py-3">
          <img
            src="/CAASIM/tutoriales/baja-de-aplicacion/1.jpg"
            alt="Iniciar Sesión"
            className="img-reesize"
          />
          <img
            src="/CAASIM/tutoriales/baja-de-aplicacion/2.jpg"
            alt="Servicios en Línea"
            className="img-reesize"
          />
        </div>

        <p>
          <strong>2.- Eliminar cuenta:</strong> Para continuar asegúrate de recordar tu pin de seguridad para poder ingresar a la sección parental de la aplicación. Una vez ingresado a la sección parental buscamos la opción llamada “Eliminar cuenta” para continuar.
        </p>

        <div className="tutorial-image-container py-3">
          <img
            src="/CAASIM/tutoriales/baja-de-aplicacion/3.jpg"
            alt="Eliminar cuenta"
            className="img-reesize"
          />
          <img
            src="/CAASIM/tutoriales/baja-de-aplicacion/4.jpg"
            alt="Eliminar cuenta"
            className="img-reesize"
          />
        </div>

        <p>
          <strong>3. Confirma la baja:</strong> Una vez seleccionada la opción “Eliminar cuenta” se mostrará otra pantalla en la cual nos solicitará nuevamente el “Pin de seguridad” para confirmar y continuar con la eliminación de la cuenta.
        </p>

        <div className="tutorial-image-container-1 pt-1 pb-4">
          <img
            src="/CAASIM/tutoriales/baja-de-aplicacion/5.jpg"
            alt="Borrar Cuenta"
            className="img-reesize-2"
          />
        </div>

        <p>
          <strong>4. Revisa tu cuenta:</strong> Después de dar de baja la cuenta, verifica que ya no puedas acceder a ella intentando iniciar sesión. Si no puedes iniciar sesión, la cuenta se ha eliminado correctamente.
        </p>
      </div>
    </div>
  );
};

export default BajaDeAplicacion;
